import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import { descripcionItem, itemsCompra } from '../datosSmartScan';
import colores from '../../Impresion/Bandeja/coloresBandeja';

const useStyles = makeStyles(() => ({
  linea: {
    padding: '10px 12px',
    borderLeft: '4px solid',
    borderBottom: `1px solid ${colores.linea}`,
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  resuelta: {
    borderLeftColor: colores.ok,
    backgroundColor: '#f6fbf6'
  },
  pendiente: {
    borderLeftColor: '#fb8c00',
    backgroundColor: '#fff8f0'
  },
  encabezado: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    gap: '12px',
    flexWrap: 'wrap'
  },
  texto: {
    fontWeight: 500,
    fontSize: '14px',
    wordBreak: 'break-word'
  },
  detalle: {
    fontSize: '12px',
    color: colores.secundario,
    whiteSpace: 'nowrap'
  },
  imputacion: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '6px',
    marginTop: '6px',
    fontSize: '13px'
  },
  ok: {
    color: colores.ok
  },
  aprendido: {
    fontSize: '12px',
    color: colores.tenue
  },
  cambiar: {
    border: 'none',
    background: 'none',
    padding: 0,
    marginLeft: 'auto',
    color: colores.primarioOscuro,
    cursor: 'pointer',
    fontSize: '12px',
    fontFamily: 'inherit',
    textDecoration: 'underline'
  },
  sinCoincidencia: {
    color: '#e65100'
  },
  select: {
    marginTop: '8px',
    backgroundColor: 'white'
  }
}));

/**
 * Una línea, impuesto o percepción y su ítem de compra de Eiffel: verde si ya está asignado (por una elección
 * anterior para ese proveedor o a mano) o un selector con los candidatos ordenados por parecido.
 */
const LineaImputacion = ({ texto, detalle, linea, soloLectura, onAsignar }) => {
  const classes = useStyles();
  const [cambiando, setCambiando] = useState(false);

  const resuelta = !!linea.itemCompra && !cambiando;
  const codigosCandidatos = linea.candidatos.map((c) => c.itemCompra);
  const otros = itemsCompra.filter((item) => !codigosCandidatos.includes(item.codigo));

  const elegir = (codigo) => {
    if (!codigo) return;
    setCambiando(false);
    onAsignar(codigo);
  };

  return (
    <div className={`${classes.linea} ${resuelta ? classes.resuelta : classes.pendiente}`}>
      <div className={classes.encabezado}>
        <span className={classes.texto}>{texto}</span>
        <span className={classes.detalle}>{detalle}</span>
      </div>

      {resuelta ? (
        <div className={classes.imputacion}>
          <CheckCircleIcon className={classes.ok} style={{ fontSize: 16 }} />
          <span className={classes.ok}>
            Ítem de compra: <b>{linea.itemCompra}</b> · {descripcionItem(linea.itemCompra)}
          </span>
          {linea.aprendido && <span className={classes.aprendido}>(recordado de facturas anteriores)</span>}
          {!soloLectura && (
            <button type="button" className={classes.cambiar} onClick={() => setCambiando(true)}>
              Cambiar
            </button>
          )}
        </div>
      ) : (
        <React.Fragment>
          <div className={classes.imputacion}>
            <HelpOutlineIcon className={classes.sinCoincidencia} style={{ fontSize: 16 }} />
            <span className={classes.sinCoincidencia}>
              {cambiando ? 'Elegí otro ítem de compra' : 'Sin coincidencia exacta en el catálogo del proveedor'}
            </span>
          </div>
          <TextField
            select
            fullWidth
            size="small"
            variant="outlined"
            className={classes.select}
            value=""
            onChange={(event) => elegir(event.target.value)}
            onBlur={() => setCambiando(false)}
            SelectProps={{ native: true }}
          >
            <option value="">Elegí un ítem de compra…</option>
            {linea.candidatos.length > 0 && (
              <optgroup label="Sugeridos por parecido">
                {linea.candidatos.map((candidato, indice) => (
                  <option key={candidato.itemCompra} value={candidato.itemCompra}>
                    {`${candidato.itemCompra} · ${descripcionItem(candidato.itemCompra)} ${indice === 0 ? '— sugerido' : `(${candidato.score}%)`}`}
                  </option>
                ))}
              </optgroup>
            )}
            <optgroup label="Otros ítems de compra">
              {otros.map((item) => (
                <option key={item.codigo} value={item.codigo}>{`${item.codigo} · ${item.descripcion}`}</option>
              ))}
            </optgroup>
          </TextField>
        </React.Fragment>
      )}
    </div>
  );
};

export default LineaImputacion;
